import { connect } from 'react-redux';

import {
  selectLandedOnPageOne,
  selectRedirectedFromSearch,
} from 'src/components/organisms/ProductPages/modules/selectors';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectShowFeaturedProduct } from 'src/redux/products/selectors';
import { HeaderCopyBlock } from '../components/HeaderCopyBlock';

const mapStateToProps = (state: ReduxApplicationState) => ({
  categoryDescription: state.products.category!.description,
  navigation: state.products.navigation,
  categoryHeading: state.products.category!.heading,
  landedOnPageOne: selectLandedOnPageOne(state),
  openOnMount: !selectRedirectedFromSearch(state) && !selectShowFeaturedProduct(state),
});

export const HeaderCopyBlockContainer = connect(mapStateToProps)(HeaderCopyBlock);
